import React from "react"
import { useQuery } from "@tanstack/react-query"
import { TslNewsletterService } from "services/api-workers-service"
import styled from "styled-components"
import { Box } from "ui/components/atoms/_atoms"
import Spinner from "ui/components/atoms/spinner"
import { Label, Title } from "ui/components/atoms/typography"

const KpiCard = ({
  label,
  value,
  loading,
}: {
  label: string
  value: number | string
  loading: boolean
}) => (
  <Card>
    <Label $type="secondary" $marginBottom="XS">
      {label}
    </Label>
    {loading ? (
      <Spinner $size="20px" />
    ) : (
      <Title $type="primary" $fontSize="XXXL" $marginBottom="0">
        {value}
      </Title>
    )}
  </Card>
)

const Dashboard = () => {
  const { data: sources, isLoading: loadingSources } = useQuery({
    queryKey: ["tsl", "sources", "kpi"],
    queryFn: () => TslNewsletterService.listSources({ active: true, limit: 1 }),
  })

  const today = new Date()
  today.setHours(0, 0, 0, 0)
  const dateFrom = today.toISOString()

  const { data: articles, isLoading: loadingArticles } = useQuery({
    queryKey: ["tsl", "articles", "kpi", dateFrom],
    queryFn: () =>
      TslNewsletterService.listArticles({
        status: "processed",
        date_from: dateFrom,
        limit: 1,
      }),
  })

  const { data: subscribers, isLoading: loadingSubscribers } = useQuery({
    queryKey: ["tsl", "subscribers", "kpi"],
    queryFn: () => TslNewsletterService.listSubscribers({ active: true, limit: 1 }),
  })

  return (
    <>
      <Grid>
        <KpiCard label="Aktywne źródła" value={sources?.total ?? 0} loading={loadingSources} />
        <KpiCard label="Artykuły dziś" value={articles?.total ?? 0} loading={loadingArticles} />
        <KpiCard
          label="Aktywni subskrybenci"
          value={subscribers?.total ?? 0}
          loading={loadingSubscribers}
        />
      </Grid>
    </>
  )
}

export default Dashboard

const Grid = styled(Box)`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: ${({ theme }) => theme.space.S};

  @media (max-width: 1100px) {
    grid-template-columns: repeat(2, 1fr);
  }
`

const Card = styled(Box)`
  background: white;
  border: 1px solid ${({ theme }) => theme.color.border};
  border-radius: ${({ theme }) => theme.variable.borderRadius};
  padding: ${({ theme }) => theme.space.S};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.space.XS};
`
